<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>智能外呼管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="任务描述"
                        prop="title">
            <el-input placeholder="任务描述" clearable
                      v-model="search.title"></el-input>
          </el-form-item>
          <el-form-item label="状态"
                        prop="status">
            <el-select v-model="search.status" clearable
                       class="width-max">
              <el-option v-for="(label, value) in status"
                         :key="value"
                         :label="label"
                         :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ID"
                        prop="id">
            <el-input placeholder="请输入任务ID" clearable
                      v-model="search.id"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/intelligent-outbound-call/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="title"
                         label="任务描述"
                         min-width="120">
          <template slot-scope="scope">
            <router-link :to="`/intelligent-outbound-call/detail/${scope.row.id}`">
              <span size="mini">{{scope.row.title}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.is_ready ? status[scope.row.status] : status[scope.row.status] + ' - 正在处理'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_cnt"
                         label="总数"
                         min-width="120"></el-table-column>
        <el-table-column prop="pending_cnt"
                         label="待呼叫数"
                         min-width="120"></el-table-column>
        <el-table-column prop="closed_cnt"
                         label="不呼叫数"
                         min-width="120"></el-table-column>
        <el-table-column prop="answered_cnt"
                         label="已接通数"
                         min-width="120"></el-table-column>
        <el-table-column prop="noanswered_cnt"
                         label="未接通数"
                         min-width="120"></el-table-column>
        <el-table-column prop="failed_cnt"
                         label="失败数"
                         min-width="120"></el-table-column>
        <el-table-column prop="adminname"
                         label="创建人"
                         min-width="120"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="140">
          <template slot-scope="scope">
            <div class="button-gutter">
              <el-button v-if="scope.row.status === 1 && scope.row.is_ready" size="mini" style="margin-bottom: 5px"
                         @click="onStart(scope.row.id)">开始
              </el-button>
              <router-link :to="`/intelligent-outbound-call/detail-table/${scope.row.id}`" style="margin-bottom: 5px">
                <el-button size="mini">明细</el-button>
              </router-link>
              <router-link v-if="scope.row.status === 1 && scope.row.is_ready" :to="`/intelligent-outbound-call/update/${scope.row.id}`">
                <el-button size="mini"
                            type="primary">修改
                </el-button>
              </router-link>
              <el-button v-if="scope.row.status !== 3 && scope.row.is_ready" type="danger"
                          size="mini"
                          @click="onSuspend(scope.row.id)">放弃
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../intelligent-outbound-call.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        status: null,
        title: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: '智能外呼ID',
        },
        {
          key: 'name',
          text: '智能外呼名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    status: state => state.intelligentOutboundCall.status,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getIntelligentOutboundCallTable', params)
    },
    onStart (id) {
      request.common('startCallTask', {id}).then((data) => {
        this.$message.success('已开始')
        this.onRefresh()
      })
    },
    onSuspend (id) {
      request.common('suspendCallTask', {id}).then((data) => {
        this.$message.success('已放弃')
        this.onRefresh()
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/pages/IntelligentOutboundCallTable.vue